import {Pipe, PipeTransform} from '@angular/core';
import {RolePermissionRow} from '../models/roles-table.model';
import {MatTableDataSource} from '@angular/material/table';

@Pipe({
  name: 'isChildDisabled',
  standalone: true,
})
export class IsChildDisabledPipe implements PipeTransform {
  transform(row: RolePermissionRow, roleName: string, dataSource: MatTableDataSource<RolePermissionRow>): boolean {
    if (!row.isChild || !row.parentKey) return false;
    const parentRow = dataSource.data.find(r => r.key === row.parentKey);
    if (!parentRow) return false;
    return !parentRow.roles[roleName]?.active;
  }
}
